export enum CreditDebit {
  CREDIT = "credit",
  DEBIT = "debit",
  BOTH = "both",
}
